import script from "./NewSolutionThanksModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewSolutionThanksModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewSolutionThanksModal.vue?vue&type=style&index=0&id=ee51b810&scoped=true&lang=css"
import "./NewSolutionThanksModal.vue?vue&type=style&index=1&id=ee51b810&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee51b810"]])

export default __exports__